import { useCurrentUser } from "../../providers/CurrentUserProvider";
import { RegisterOrLoginModal } from "../../registration/registerOrLoginModal";
import { RegistrationWizardSkeleton } from "./RegistrationWizardSkeleton";
import { RegistrationWizard } from "./RegistrationWizard";

export const RegistrationWidget = ({ team, athletes, options, registrationOptions, captureFields, paymentOptions, exclusiveSeries, register, createCheckoutSession, isSeriesRegistration, organisation }) => {
    const { loaded, currentUser } = useCurrentUser();
    const dataLoaded = !!(athletes && loaded && currentUser);

    return (
        <>
            <RegisterOrLoginModal/>
            {!dataLoaded
                ? <RegistrationWizardSkeleton/>
                : <RegistrationWizard
                    user={currentUser}
                    team={team}
                    athletes={athletes}
                    options={options}
                    registrationOptions={registrationOptions}
                    captureFields={captureFields}
                    paymentOptions={paymentOptions}
                    exclusiveSeries={exclusiveSeries}
                    register={register}
                    createCheckoutSession={createCheckoutSession}
                    isSeriesRegistration={isSeriesRegistration}
                    organisation={organisation}
                />
            }
        </>
    );
};
